<template>

<div class="page">

    <!-- 面包屑 -->

    <Breadcrumb
        title="店面业绩区间表"
    />

    <!-- 顶部 -->

    <div class="page-header">

        <div class="title">
            店面业绩区间表
        </div>

        <div class="desc">
            上传门店业绩Excel文件，
            自动生成业绩区间统计报表
        </div>

    </div>

    <!-- 上传 -->

    <UploadExcel
        title="📊 店面业绩区间表"
        description="上传门店业绩明细表，系统自动生成业绩区间统计报表"
        @success="handleUpload"
    />

    <!-- 操作栏 -->

    <div
        class="toolbar"
        v-if="tableData.length"
    >

        <button
            class="export-btn"
            @click="handleExport"
        >
            📥 导出店面业绩区间表
        </button>

    </div>

    <!-- 数据预览 -->

    <div
        class="preview-card"
        v-if="tableData.length"
    >

        <div class="card-title">
            数据预览
        </div>

        <PerformancePreview
            :data="tableData"
        />

    </div>

</div>

</template>

<script>

import Breadcrumb
from '@/components/Breadcrumb.vue'

import UploadExcel
from '@/components/UploadExcel.vue'

import PerformancePreview
from '@/components/PerformancePreview.vue'

import {
    analyse
}
from '@/reports/performance/analyser'

import {
    exportPerformance
}
from '@/reports/performance/exporter'

export default {

    name:'PerformanceReport',

    components:{

        Breadcrumb,

        UploadExcel,

        PerformancePreview

    },

    data(){

        return{

            tableData:[]

        }

    },

    methods:{

        handleUpload(rows){

            try{

                this.tableData =
                    analyse(rows)

            }
            catch(error){

                console.error(error)

                alert(
                    '文件解析失败'
                )

            }

        },

        handleExport(){

            if(
                !this.tableData.length
            ){

                alert(
                    '暂无可导出的数据'
                )

                return

            }

            exportPerformance(
                this.tableData
            )

        }

    }

}

</script>

<style scoped>

.page{

    padding:20px;

    background:#f5f6f8;

    min-height:100vh;

}

.page-header{

    background:#fff;

    padding:24px;

    border-radius:12px;

    margin-bottom:20px;

    box-shadow:
      0 2px 8px rgba(0,0,0,.05);

}

.title{

    font-size:26px;

    font-weight:600;

    color:#333;

}

.desc{

    margin-top:10px;

    color:#666;

}

.toolbar{

    margin:20px 0;

}

.export-btn{

    background:#c00000;

    color:#fff;

    border:none;

    border-radius:8px;

    padding:12px 24px;

    cursor:pointer;

    font-size:14px;

    font-weight:600;

}

.export-btn:hover{

    background:#a50000;

}

.preview-card{

    background:#fff;

    padding:20px;

    border-radius:12px;

    box-shadow:
      0 2px 8px rgba(0,0,0,.05);

}

.card-title{

    font-size:18px;

    font-weight:600;

    margin-bottom:20px;

}

</style>